// extracted by mini-css-extract-plugin
module.exports = {"container":"tmedical_container__NY4X3","room":"tmedical_room__2C9ZO","title":"tmedical_title__12nre","content":"tmedical_content___rsJ4"};